import { createAction } from '@reduxjs/toolkit';

export const clearBreadcrumbs = createAction('breadcrumbs/clearBreadcrumbs');
